import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.driver || initialState;

const makeSelectOrdersList = () =>
  createSelector(select, subState => subState.ordersList);
const makeSelectCountOrdersList = () =>
  createSelector(select, subState => subState.ordersList);
const makeSelectError = () =>
  createSelector(select, subState => subState.ordersList);
const makeSelectLoading = () =>
  createSelector(select, subState => subState.ordersList);

export default select;
export {
  makeSelectOrdersList,
  makeSelectCountOrdersList,
  makeSelectError,
  makeSelectLoading,
};
